<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Trạng thái di chuyển"
          :link="[
            {
              text: 'Trạng thái di chuyển',
              href: 'bus-register'
            }
          ]"
        />
      </div>
      <v-btn
        @click="() => $refs['add-attendance-dialog'].openDialog()"
        @refresh="$refs['bus-register-table'].paginationChange()"
        class="ml-6"
        dark
        color="#0D47A1"
      >
        <v-icon left>add</v-icon>Thêm điểm danh
      </v-btn>
    </div>

    <v-card outlined class="mx-4 elevation-0"> <BusRegisterFilter /> </v-card>
    <v-card outlined class="mx-4 elevation-0 mt-6"> <BusRegisterTodayTable ref="bus-register-table" /> </v-card>
    <AddAttendanceDialog ref="add-attendance-dialog" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import AddAttendanceDialog from '@/views/attendance/components/AddAttendanceDialog.vue'
import BusRegisterTodayTable from '../../modules/bus/bus-register/BusRegisterTodayTable.vue'
import BusRegisterFilter from '../../modules/bus/bus-register/BusRegisterFilter.vue'

export default {
  components: {
    Breadcrumbs,
    BusRegisterTodayTable,
    BusRegisterFilter,
    AddAttendanceDialog
  }
}
</script>
